import { graphql } from "gql.tada";

const DepartmentListQry = graphql(`
  query ($input: DepartmentListInput!) {
    departments(input: $input) {
      items {
        id
        key
        name
      }
    }
  }
`);

export { DepartmentListQry };
